export const classes = {
  container: {
    display: 'grid',
  },
  mainPageContainer: {
    color: 'text.secondary',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '120px',
    marginLeft: '220px',
    display: 'flex',
  },
  pageContainer: {
    color: 'text.secondary',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: '250px',
    display: 'flex',
    paddingTop: '77px',
    paddingBottom: '100px',
    overflowX: 'scroll',
  },
  heading: {
    color: '#5768C7',
    marginBottom: '30px',
  },
  commonMargin: {
    marginTop: '150px',
    marginLeft: '220px',
  },
  buttonMargin: {
    marginRight: '20px',
  },
  paperContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > :not(style)': {
      width: 'auto',
      height: 'auto',
      maxWidth: 1110,
      padding: 3,
      marginTop: 3,
    },
  },
  buttonsContainer: {
    marginTop: 5,
  },
  floatingButton: {
    display: 'absolute',
    position: 'fixed',
    bottom: '50px',
    right: '50px',
    zIndex: 444,
  },
  commonTextFieldWidth: {
    width: '400px',
  },
  noData: {
    marginTop: '15%',
    marginLeft: '10%',
  },
};

export const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
  borderRadius: 5,
  border: '1px solid lightgrey',
};

export const fileIconColor = {
  color: 'grey',
  marginBottom: '10px',
};

export const thumb = {
  display: 'inline-flex',
  marginBottom: 8,
  marginRight: 8,
  width: 400,
  height: 400,
  padding: 4,
  boxSizing: 'border-box',
};

export const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

export const img = {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};
